export default __webpack_public_path__ + "static/media/daily-commission.bc43792a.svg";